import React from "react";
import styles from "./connectorRods.module.css";

export default function ConnectorRods({ double = true, className }) {
  return (
    <div className={`${styles.connectorRods} ${className}`}>
      {double && <div className={`${styles.rod} ${styles.rod1}`} />}
      <div className={styles.rod} />
    </div>
  );
}
